import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 1,
  class: "contact-avatar__initials",
  "aria-hidden": "true"
}

import { computed, ref, watch } from "vue";

// A contact's profile photo, or their initials when there's none (or it fails to load:
// LinkedIn photo links expire).

export default /*@__PURE__*/_defineComponent({
  __name: 'ContactAvatar',
  props: {
    name: {},
    src: { default: null },
    size: { default: 36 }
  },
  setup(__props: any) {

const props = __props;

const failed = ref(false);
watch(
  () => props.src,
  () => (failed.value = false)
);

const initials = computed(() => {
  const parts = props.name.trim().split(/\s+/).filter(Boolean);
  const letters = parts.length > 1 ? [parts[0], parts[parts.length - 1]] : parts;
  return letters.map((p) => p[0]!.toUpperCase()).join("") || "?";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: "contact-avatar",
    style: _normalizeStyle({ width: `${__props.size}px`, height: `${__props.size}px`, fontSize: `${Math.round(__props.size * 0.38)}px` }),
    title: __props.name
  }, [
    (__props.src && !failed.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: __props.src,
          alt: __props.name,
          class: "contact-avatar__img",
          referrerpolicy: "no-referrer",
          onError: _cache[0] || (_cache[0] = ($event: any) => (failed.value = true))
        }, null, 40, _hoisted_2))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(initials.value), 1))
  ], 12, _hoisted_1))
}
}

})